import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { Form, Input, Button, Layout, Typography, Alert } from 'antd';

const { Content } = Layout;
const { Title } = Typography;

const ForgotPasswordPage: React.FC = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [error, setError] = useState<string | null>(null);
  const [email, setEmail] = useState<string>('');
  const navigate = useNavigate();

  const handleSendCode = async (values: any) => {
    try {
      const { email } = values;
      setEmail(email);
      const output = await resetPassword({ username: email });
      if (
        output.nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE'
      ) {
        setStep(2);
      }
    } catch (error) {
      setError('Error sending verification code. Please try again.');
      console.error('Error sending verification code:', error);
    }
  };

  const handleResetPassword = async (values: any) => {
    try {
      const { code, newPassword } = values;
      await confirmResetPassword({
        username: email,
        confirmationCode: code,
        newPassword,
      });

      if (location.state?.formPage)
        navigate('/login', { state: { formPage: true } });
      else navigate('/login');
    } catch (error) {
      setError('Error resetting password. Please try again.');
      console.error('Error resetting password:', error);
    }
  };

  return (
    <Layout
      style={{
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Content style={{ padding: '50px', maxWidth: '600px', width: '100%' }}>
        <Title level={2} style={{ textAlign: 'center' }}>
          Forgot Password
        </Title>
        {error && (
          <Alert
            message={error}
            type='error'
            showIcon
            style={{ marginBottom: '20px' }}
          />
        )}
        {step === 1 ? (
          <Form form={form} layout='vertical' onFinish={handleSendCode}>
            <Form.Item
              name='email'
              label='Email'
              rules={[{ required: true, message: 'Please enter your email' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                Send Verification Code
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form form={form} layout='vertical' onFinish={handleResetPassword}>
            <Form.Item
              name='code'
              label='Verification Code'
              rules={[
                {
                  required: true,
                  message: 'Please enter the verification code',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name='newPassword'
              label='New Password'
              rules={[
                { required: true, message: 'Please enter your new password' },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        )}
      </Content>
    </Layout>
  );
};

export default ForgotPasswordPage;
